import 'babel-polyfill'
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import 'ol/ol.css'
import '@supermap/iclient-ol/dist/iclient-openlayers.min.css'
// import 'leaflet/dist/leaflet.css'
// import '@supermap/iclient-leaflet'
// import 'leaflet-draw/dist/leaflet.draw.css'
// import 'leaflet-draw'
//import 'leaflet-draw/dist/leaflet.draw-src'

Vue.use(VueResource)

import qs from 'qs'
Vue.prototype.$qs = qs;

router.beforeEach((to,from,next)=>{
  if(to.matched.some(record => record.meta.requireAuth)){//判断该路由是否需要登录权限
    if(sessionStorage.getItem('setToken')){//判断当前的token是否存在，登录存入的token
      next();
    }
    else{
      next({
        path:'/',
        query:{redirect:to.fullPath}//将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else{
    next();
  }
})
import store from './store'
import './plugins/element.js'
import echarts from 'echarts'
Vue.prototype.$echarts=echarts
import Marquee from 'vue-marquee';

Vue.config.productionTip = false

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'videojs-flash'
Vue.use(VideoPlayer)

import VueVideoPlayer from 'vue-video-player'
Vue.use(VueVideoPlayer)

import VueBus from 'vue-bus';
Vue.use(VueBus);

const hls = require('videojs-contrib-hls')
Vue.use(hls)

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

import '@babel/polyfill';
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上


// import common from './common'
// Vue.prototype.$common = common

import axios from 'axios'
Vue.prototype.$axios=axios;



// Vue.prototype.$mainUrl = "http://222.190.125.42:8081/"; // 非大屏接口
// Vue.prototype.$newMainUrl = "http://222.190.125.42:8081/"; // 大屏接口


//Vue.prototype.$mainUrl = "http://127.0.0.1:8082/"; // 非大屏接口
//Vue.prototype.$newMainUrl = "http://127.0.0.1:8082/"; // 大屏接口
Vue.prototype.$dns = "127.0.0.1"
//Vue.prototype.$mainUrl = "http://192.168.1.98:8082/"; // 济南外网
Vue.prototype.$mainUrl = "http://njhouhuatest.vicp.cc:8082/"; // 济南外网
//Vue.prototype.$mainUrl = "http://192.168.1.116:8082/"; // 济南外网
//Vue.prototype.$mainUrl = "http://172.16.16.3:8082/"; // 济南外网
//Vue.prototype.$mainUrl = "http://58.222.10.6:8082/"; // 非大屏接口
//Vue.prototype.$mainUrl = "http://139.196.193.231:8082/"; // 非大屏接口
//Vue.prototype.$newMainUrl = "http://192.168.1.98:8082/"; // 济南外网
Vue.prototype.$newMainUrl = "http://njhouhuatest.vicp.cc:8082/"; // 济南外网
//Vue.prototype.$newMainUrl = "http://192.168.1.116:8082/"; // 济南外网
//Vue.prototype.$newMainUrl = "http://58.222.10.6:8082/"; // 济南外网
//Vue.prototype.$newMainUrl = "http://139.196.193.231:8082/"; // 大屏接口
//Vue.prototype.$newMainUrl = "http://172.16.16.3:8082/"; // 大屏接口
Vue.prototype.$mapUrl = "http://192.168.1.116:8081/geoserver/jnMap/wms"

//Vue.prototype.$ws = "ws://127.0.0.1:9010/webSocket";


//Vue.prototype.$subUrl = "http://njhouhuatest.vicp.cc:8082/";//备份服务器地址

// Vue.prototype.$mainUrl = "http://123.232.124.106:8082/"; // 非大屏接口
// Vue.prototype.$newMainUrl = "http://123.232.124.106:8082/"; // 大屏接口
// Vue.prototype.$mainUrl = "http://127.16.16.3:8082/"; // 非大屏接口
// Vue.prototype.$newMainUrl = "http://127.16.16.3:8082/"; // 大屏接口
// 引入地图
import AMap from 'vue-amap';
Vue.use(AMap);

//初始化vue-amap
AMap.initAMapApiLoader({
  // 高德的key
  key: '7bbf4518a7ff1e0e95338e0f6693c059',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
});


// 清除参数，打开请求添加模态框没有原来的添加信息
Vue.prototype.cleanArguments = function (obj) {
  for(var key in obj){
    obj[key] = null;
  }
}
// 移除表单校验，否则多次打开添加模态框会延续上次的表单校验，报一片红
Vue.prototype.resetValidate = function(formName){
  if(this.$refs[formName]!==undefined){
    this.$refs[formName].resetFields();//如果只是清除表单验证用   this.$refs[formName].clearValidate();
  }
}

Vue.prototype.drawChart = function(chart,id,option){
  // 绘制表格
  console.log('绘制表格');
  chart = echarts.init(document.getElementById(id))
  chart.setOption(option);
},



// // 初始化vue-amap
// AMap.initAMapApiLoader({
//   // 高德key
//   key: '7bbf4518a7ff1e0e95338e0f6693c059',
//   // 插件集合 （插件按需引入）
//   plugin: ['AMap.Geolocation']
// });

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
